import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import LookupService from '../../Services/LookupService';
import { LookupData } from '../../Models/LoookupData';

interface LookupState {
  companyTypeList: LookupData[];
  companyStatusList: LookupData[];
  loading: boolean;
  error: string | null;
}

const initialState: LookupState = {
  companyTypeList: [],
  companyStatusList: [],
  loading: false,
  error: null,
};

export const fetchCompanyTypeList = createAsyncThunk(
  'lookup/fetchCompanyTypeList',
  async (_, { rejectWithValue }) => {
    try {
      return await LookupService.fetchCompanyType();
    } catch (err: any) {
      return rejectWithValue(err.message);
    }
  }
);

export const fetchCompanyStatusList = createAsyncThunk(
  'lookup/fetchCompanyStatusList',
  async (_, { rejectWithValue }) => {
    try {
      return await LookupService.fetchCompanyStatus();
    } catch (err: any) {
      return rejectWithValue(err.message);
    }
  }
);

const lookupSlice = createSlice({
  name: 'lookup',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchCompanyTypeList.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCompanyTypeList.fulfilled, (state, action) => {
        state.companyTypeList = action.payload;
        state.loading = false;
      })
      .addCase(fetchCompanyTypeList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchCompanyStatusList.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCompanyStatusList.fulfilled, (state, action) => {
        state.companyStatusList = action.payload;
        state.loading = false;
      })
      .addCase(fetchCompanyStatusList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default lookupSlice.reducer;
